import { gql } from '@apollo/client';

export const EDIT_HOTEL_THEME_MUTATION = gql`
  mutation EditHotelTheme($data: updateThemeInput!) {
    updateTheme(input: $data) {
      theme {
        id
        primary
        secondary
        tertiary
        success
        warning
        danger
        dark
        medium
        light
      }
    }
  }
`;
